
import VolumeUp from "../../../assets/duotone/VolumeUp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeUpIcon({ className, dataTestid = "VolumeUpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeUp data-testid={dataTestid} className={classes} {...rest} />
  );
}
